import { selectCurrentInstitutionPath } from '../../Institutions/CurrentInstitutionPath/selectors';
import { currentCourseInstitutionSelector } from '../../Courses/selectors';
import { retrieveInstitutions } from '../../Institutions/dispatchers';

export const getCurrentInstitution = ({ dispatch, getState }) => {
  const institutionPaths = [];

  const currentInstitutionPath = selectCurrentInstitutionPath(getState());
  if (currentInstitutionPath) {
    institutionPaths.push(currentInstitutionPath);
  }

  // If there is a current course then we want to also retrieve the linked institution
  // which can be different from the currentInstitutionPath
  const currentLinkedInstitutionPath = currentCourseInstitutionSelector(
    getState()
  );
  if (currentLinkedInstitutionPath) {
    institutionPaths.push(currentLinkedInstitutionPath);
  }

  if (institutionPaths.length > 0) {
    return dispatch(retrieveInstitutions(institutionPaths));
  }

  return Promise.resolve();
};
